(() => {
  const updateWaitingCount = (container, count) => {
    const waiting = container.querySelector("[data-kbd-notify-waiting]");
    if (!waiting) return;
    const total = Number.isFinite(Number(count))
      ? Math.max(0, Number(count))
      : 0;
    waiting.textContent = `${total} ${total === 1 ? "person is" : "people are"} waiting`;
  };

  const initialize = async () => {
    const forms = document.querySelectorAll("[data-kbd-notify]");
    await Promise.all(
      Array.from(forms).map(async (container) => {
        const productId = container.dataset.productId;
        if (!productId) return;
        try {
          const response = await fetch(
            `/apps/kbd-notify/subscribe?productId=${encodeURIComponent(productId)}`,
            { headers: { Accept: "application/json" } },
          );
          const settings = await response.json();
          if (!response.ok || !settings.enabled) return;
          const button = container.querySelector(".kbd-notify__button");
          if (button) button.textContent = settings.button;
          const productDetail = container.closest(".product-detail");
          const soldOutButton =
            productDetail?.querySelector("[data-add-to-cart]");
          if (soldOutButton) soldOutButton.hidden = true;
          updateWaitingCount(container, settings.waitingCount);
          container.hidden = false;
        } catch {
          // Keep the form hidden when configuration cannot be verified.
        }
      }),
    );
  };
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", initialize);
  else initialize();

  document.addEventListener("submit", async (event) => {
    const form = event.target.closest("[data-kbd-notify-form]");
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    const message = form.querySelector("[data-kbd-notify-message]");
    const row = form.querySelector(".kbd-notify__row");
    let succeeded = false;
    button.disabled = true;
    message.textContent = "";
    try {
      const response = await fetch(form.action, {
        method: "POST",
        body: new FormData(form),
        headers: { Accept: "application/json" },
      });
      const result = await response.json();
      if (response.ok) {
        succeeded = true;
        form.reset();
        row?.classList.add("is-success");
        button.textContent =
          "You're on the list. We'll email you when it's back.";
        message.textContent = "";
        updateWaitingCount(
          form.closest("[data-kbd-notify]"),
          result.waitingCount,
        );
      } else {
        message.textContent = result.message || "Unable to subscribe.";
      }
    } catch {
      message.textContent = "Unable to subscribe. Please try again.";
    } finally {
      if (!succeeded) button.disabled = false;
    }
  });
})();
